<template>
  <div class="form-change-password mx-auto text-center my-10">
    <h1>Alterar senha</h1>
    <v-divider class="my-5"></v-divider>
    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <ValidationProvider name="currentPassword" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Senha atual"
            type="password"
            v-model="currentPassword"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>
        <ValidationProvider name="newPassword" rules="required" v-slot="{ errors }">
          <v-text-field
            label="Nova senha"
            type="password"
            v-model="newPassword"
            :error-messages="errors"
            filled
            required
          />
        </ValidationProvider>

        <v-divider class="my-5"></v-divider>

        <v-btn
          block
          rounded
          large
          class="my-2"
          type="submit"
          color="primary"
          :disabled="invalid"
        >
          Alterar
        </v-btn>
      </form>
    </ValidationObserver>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

import UserService from '@/services/user/user.service';
import RouterService from '@/services/router/router.service.ts';

const userService = new UserService();
const routerService = new RouterService();

export default {
  name: 'UserPassword',
  data: () => ({
    currentPassword: '',
    newPassword: '',
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    onSubmit() {
      this.$refs.observer.validate();

      this.loading = true;

      userService.changePassword({
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      })
      .then((response) => {
        this.showSnack(response.data.message);

        this.loading = false;
        this.$router.push(routerService.getHomeRoute());
      })
      .catch((err) => {
        this.loading = false;
        this.showSnack(err?.response?.data?.message ?? 'Falha ao atualizar senha');
      });
    }
  },
};
</script>

<style scoped>
.form-change-password {
  max-width: 50%;
}
</style>
